<template>
  <div>
    <div>
      <label>
        <input v-model="value2" type="checkbox" :disabled="disabled" />
        {{ labelYes }}
      </label>
      <div>
        <span v-for="item in errorMsgs">{{ item }}</span>
      </div>
    </div>
    <div>
      <label
        ><input
          v-model="value3"
          v-on:change="value2 = !value3"
          type="checkbox"
          :disabled="disabled"
        />
        {{ labelNo }}
      </label>
      <div>
        <span v-for="item in errorMsgs">{{ item }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import InputBase from "./InputBase";
export default {
  mixins: [InputBase],
  props: [
    "appendIcon",
    "appendIconCb",
    "appendOuterIcon",
    "appendOuterIconCb",
    "prependIcon",
    "disabled",
    "labelYes",
    "labelNo",
  ],
  data() {
    return {
      value2: null,
      value3: null,
    };
  },
  created: () => {
    this.value2 = this.value;
    this.value3 = this.value === null ? null : !this.value;
  },
  watch: {
    value2(v) {
      this.emit(v);
      this.touch();
      this.value3 = !this.value2;
    },

    value: {
      handler(va, old) {
        if (va === this.value2) return;
        this.value2 = va;
        this.value3 = !va;
      },
      immediate: true,
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/public_app/elements/YesNoSwitch.vue